module.exports = __webpack_public_path__ + "static/media/Hexagon.f04a7e4a.svg";